import React, { Component } from 'react';
import { Modal } from 'antd';
// personal component
import NewTree from '../component/new_tree.js';

class UpdataRelative extends Component {

	// 确认删除
	handleOk = () => {
		const { onOk } = this.props;
		onOk && onOk();
	}

	// 取消删除
	handleCancel = () => {
		const { onCancel } = this.props;
		onCancel && onCancel();
	}

	// 点击树节点
	onChapterSelect = (selectedKeys, other) => {
		const { onUpdataSelect } = this.props;
		onUpdataSelect && onUpdataSelect(selectedKeys, other)
	}

	render() {
		const { isShowUpdataModal, list } = this.props;

		const loop = data => data.map((item) => {
			if (item.children && item.children.length) {
				return <TreeNode key={item.key} title={item.title}>{loop(item.children)}</TreeNode>;
			}
			return <TreeNode key={item.key} title={item.title} />;
		});

		return (
			<Modal
				title="新关联关系"
				visible={isShowUpdataModal}
				cancelText="取消"
				okText="确认"
				onOk={this.handleOk}
				onCancel={this.handleCancel}>
				<div className="updata-relative">
					<NewTree
				        onSelect={this.onChapterSelect}
				        list={list}
				        showLine={false}
				    />
				</div>
			</Modal>
		)
	}
}

export default UpdataRelative;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/modal/updata_relative.js